import { Button, Cell, Grid, Heading, Tag, Text, Tooltip, VFlow } from 'bold-ui'
import { useAlert } from 'components/alert'
import { Box } from 'components/Box'
import { DateTime } from 'components/date'
import useFirebase from 'components/firebase/useFirebase'
import { Form } from 'components/form'
import { confirm } from 'components/modals/confirm'
import { useAlterarHorusMutation } from 'graphql/hooks.generated'
import { ConexaoQuery } from 'graphql/types.generated'
import React from 'react'
import { FormRenderProps } from 'react-final-form'

import { IntervaloHorusSelectField, IntervaloHorusSelectModel, items } from './IntervaloHorusSelectField'

interface ConfiguracoesHorusBoxProps {
  horus: ConexaoQuery['conexao']['horus']
  internetHabilitada: boolean

  load(): void
}

interface FormType {
  intervalo: IntervaloHorusSelectModel
}

export function ConfiguracoesHorusBox(props: ConfiguracoesHorusBoxProps) {
  const { horus, internetHabilitada } = props
  const alert = useAlert()
  const { analytics } = useFirebase()
  const [alterarHorus] = useAlterarHorusMutation()

  const handleSubmit = (values: FormType) => {
    if (horus.habilitado) {
      confirm({
        title: 'Deseja desabilitar a conexão com o Hórus?',
        body:
          'A conexão com o Hórus deve ser desabilitada somente em casos de instabilidade ' +
          'da conexão com a Internet ou do serviço do Hórus.',
        confirmLabel: 'Desabilitar',
        onConfirm: () => {
          analytics.logEvent('desabilita_horus')
          submitIntervalo(values, 'Conexão com o Hórus foi desabilitada com sucesso')
        },
      })()
    } else {
      analytics.logEvent('habilita_horus')
      submitIntervalo(values, 'Conexão com o Hórus foi habilitada com sucesso')
    }
  }

  const submitIntervalo = (values: FormType, msg: string) => {
    return alterarHorus({
      variables: {
        alterarHorusInput: {
          id: '1',
          habilitado: !horus.habilitado,
          intervalo: values.intervalo && values.intervalo.value,
        },
      },
    }).then(() => {
      alert('success', msg)
    })
  }

  const renderForm = (formProps: FormRenderProps) => {
    return (
      <Box style={{ height: '100%' }}>
        <Grid>
          <Cell flexGrow={1}>
            <VFlow>
              <Heading level={3} style={{ display: 'inline' }}>
                Hórus
              </Heading>

              {!horus.habilitado ? (
                <Tooltip text={!internetHabilitada && 'Não pode ser habilitada sem conexão com a internet'}>
                  <Button
                    kind='primary'
                    size='small'
                    onClick={formProps.handleSubmit}
                    disabled={!internetHabilitada}
                    style={{ marginTop: '1.5rem' }}
                  >
                    Habilitar
                  </Button>
                </Tooltip>
              ) : (
                <Grid gap={1}>
                  <Cell flexGrow={1}>
                    <IntervaloHorusSelectField name='intervalo' />
                  </Cell>
                  <Cell>
                    <Button
                      kind='primary'
                      size='small'
                      onClick={formProps.handleSubmit}
                      style={{ marginTop: '1.5rem' }}
                    >
                      Desabilitar
                    </Button>
                  </Cell>
                </Grid>
              )}
            </VFlow>
          </Cell>
          <Cell style={{ textAlign: 'right' }}>
            <VFlow>
              {horus.habilitado ? (
                <Tag type='success' icon='checkCircleFilled'>
                  Habilitado
                </Tag>
              ) : (
                <Tag type='normal' icon='banFilled'>
                  Desabilitado
                </Tag>
              )}

              {!horus.habilitado && horus.desabilitadoAteData && (
                <Text>
                  Desabilitado até <DateTime value={horus.desabilitadoAteData} />.
                </Text>
              )}

              {!horus.habilitado && !horus.desabilitadoAteData && <Text>Desabilitado por tempo indeterminado.</Text>}
            </VFlow>
          </Cell>
        </Grid>
      </Box>
    )
  }

  const intervaloValue = horus.habilitado ? items[1] : undefined
  const initialValues = { ...horus, intervalo: intervaloValue }

  return <Form onSubmit={handleSubmit} initialValues={initialValues} render={renderForm} />
}
